import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  ProcessAutomationInvocation,
  ProcessAutomationSession,
  ProcessAutomationWorkflow,
} from './model/process-automation';
import {
  isRunActive,
  markWorkflowTriggered,
} from './+state/ccf-process-automation.slice';
import { startProcessAutomationWorkflow } from './process-automation-engine';

/**
 * Auto runs the "Rule - Auto run" workflows of the journey once per contact,
 * as soon as the chat is open (rule-based execution in the product).
 * @param contact - active contact
 * @param workflows - workflows of the journey
 * @param session - Process Automation session of the contact
 * @example useProcessAutomationTriggers(contact, workflows, session)
 */
export const useProcessAutomationTriggers = (
  contact: any,
  workflows: ProcessAutomationWorkflow[],
  session: ProcessAutomationSession
) => {
  const dispatch = useDispatch();
  const contactId = String(contact?.id ?? '');

  useEffect(() => {
    if (!contactId || isRunActive(session.activeRun)) return;
    const workflow = workflows.find(
      (item) =>
        item.invocation === ProcessAutomationInvocation.AUTO_RUN &&
        !session.triggeredWorkflowIds.includes(item.id)
    );
    if (!workflow) return;
    dispatch(markWorkflowTriggered({ contactId, workflowId: workflow.id }));
    dispatch(startProcessAutomationWorkflow(workflow, contact));
  }, [contactId, workflows, session.triggeredWorkflowIds, session.activeRun]);
};

export default useProcessAutomationTriggers;
